"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomerDeviceRequest = exports.isWideawakeUpdateDeleteSQSMessageAttributes = void 0;
const isWideawakeUpdateDeleteSQSMessageAttributes = (x) => {
    const c = x;
    return !!c && ['UPDATE', 'DELETE'].includes(c.Action) && typeof c.Source === 'string';
};
exports.isWideawakeUpdateDeleteSQSMessageAttributes = isWideawakeUpdateDeleteSQSMessageAttributes;
/** Wideawake API */
const isCustomerDeviceRequest = (parsedData) => {
    const request = parsedData;
    return true;
};
exports.isCustomerDeviceRequest = isCustomerDeviceRequest;
